import { ElementRef, NgZone } from '@angular/core';
import { forkJoin } from 'rxjs';
import Sortable from 'sortablejs';
import { SecuritiesService } from '../../services/securities.service';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "../../services/securities.service";
import * as i2 from "../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["holdingsContainer"];
const _c1 = a0 => ({ "plate-purple": a0 });
function EditHoldingsModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function EditHoldingsModalComponent_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.restoreDefaults()); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Restore Defaults");
    i0.ɵɵelementEnd()();
} }
function EditHoldingsModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.loadingMessage);
} }
function EditHoldingsModalComponent_div_11_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26)(3, "div", 27)(4, "div", 28);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 30)(9, "div", 31);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 32);
    i0.ɵɵlistener("click", function EditHoldingsModalComponent_div_11_div_10_Template_div_click_11_listener() { const index_r5 = i0.ɵɵrestoreView(_r4).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeRelatedSecurity(index_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 8);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const holding_r6 = ctx.$implicit;
    const index_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, index_r5 + 1 <= ctx_r1.maxDisplayHoldings));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", index_r5 + 1, ". ", holding_r6.displaySecurityId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-reorder-up");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
function EditHoldingsModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "div", 18)(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 19);
    i0.ɵɵelementStart(6, "ycn-add-button-autocomplete", 20);
    i0.ɵɵlistener("submitHandler", function EditHoldingsModalComponent_div_11_Template_ycn_add_button_autocomplete_submitHandler_6_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.autocompleteHandler($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 21)(8, "div", 22, 0);
    i0.ɵɵtemplate(10, EditHoldingsModalComponent_div_11_div_10_Template, 13, 8, "div", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "div", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.modalText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("searchType", "main")("searchableSecurityIds", ctx_r1.searchableSecurityIds)("isDisabled", ctx_r1.searchableSecurityIds.length === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.relatedHoldings)("ngForTrackBy", ctx_r1.trackBySecurityId);
} }
/**
 * Edit Holdings Modal Component
 *
 * Modal with a security autocomplete bar and a sortable list of the related holdings for a security.
 *
 * Input Properties:
 *  maxHoldings: Max number of securities supported by the list.
 *  maxDisplayHoldings: Max number of display securities to highlight.
 *  searchType: Search type to modify the results for the autocomplete.
 *  securityId: Current security ID.
 *  shouldReloadPage: Whether the page should reload once related holdings have been successfully updated.
 *  showRestoreDefaults: Flag to show the Restore Defaults button.
 */
export class EditHoldingsModalComponent {
    constructor(securitiesService, ngZone) {
        this.securitiesService = securitiesService;
        this.ngZone = ngZone;
        this.shouldReloadPage = false;
        this.loadingMessage = null;
        this.open = false;
        this.sortableInitialized = false;
        this.errorText = '';
        this.relatedHoldings = [];
        this.originalRelatedHoldings = [];
        this.defaultRelatedHoldings = [];
        this.searchableSecurityIds = [];
    }
    ngOnInit() {
        this.modalText = `Drag and drop to reorder or search security to add. Only top 
         ${this.maxDisplayHoldings} holdings are shown.`;
        if (window.USER.authenticated) {
            this.setRelatedHoldings();
        }
    }
    /**
     * Opens the modal and initializes `Sortable`.
     */
    openModal() {
        this.relatedHoldings = [...this.originalRelatedHoldings];
        if (!this.sortableInitialized) {
            this.initializeSortable();
        }
        this.errorText = '';
        this.open = true;
    }
    /**
     * Closes the modal and restores the original security list.
     */
    closeModal() {
        this.open = false;
    }
    /**
     * Set the default related holdings and user related holdings for the security.
     */
    setRelatedHoldings() {
        forkJoin([
            this.securitiesService.getHoldings(this.securityId, {
                resultsPerPage: 10000,
                useFundTop25: false,
                heldSecurityRequired: true,
            }),
            this.securitiesService.getUserRelatedHoldings(this.securityId),
        ]).subscribe(([holdings, userHoldings]) => {
            holdings.holdings_data.forEach((holding) => {
                if (this.defaultRelatedHoldings.length < this.maxDisplayHoldings) {
                    this.defaultRelatedHoldings.push({
                        securityId: holding.security_id,
                        displaySecurityId: holding.ticker,
                        name: holding.name,
                    });
                }
                this.searchableSecurityIds.push(holding.security_id);
            });
            if (userHoldings.length !== 0) {
                this.originalRelatedHoldings = [...userHoldings];
            }
            else {
                this.originalRelatedHoldings = [...this.defaultRelatedHoldings];
            }
        });
    }
    /**
     * Validates and updates the related securities list for the user. Then emits `submitHandler`.
     */
    submit() {
        if (this.relatedHoldings.length > this.maxHoldings) {
            this.errorText = `No more than ${this.maxHoldings} holdings are allowed.`;
            return;
        }
        // If the lists are the same, don't submit.
        let relatedHoldingIds = this.relatedHoldings.map((holding) => holding.securityId);
        const originalRelatedSecurityIds = this.originalRelatedHoldings.map((holding) => holding.securityId);
        if (relatedHoldingIds.length === originalRelatedSecurityIds.length &&
            originalRelatedSecurityIds.every((id, index) => id === relatedHoldingIds[index])) {
            this.closeModal();
            return;
        }
        // If the list is the same as the default, submit an empty list to not save duplicate data.
        const defaultRelatedHoldingIds = this.defaultRelatedHoldings.map((holding) => holding.securityId);
        if (defaultRelatedHoldingIds.length === relatedHoldingIds.length &&
            defaultRelatedHoldingIds.every((id, index) => id === relatedHoldingIds[index])) {
            relatedHoldingIds = [];
        }
        // Update the user related securities
        this.loadingMessage = this.shouldReloadPage ? 'Updating Holdings' : null;
        this.securitiesService.putUserRelatedHoldings(this.securityId, relatedHoldingIds).subscribe({
            next: () => {
                this.loadingMessage = this.shouldReloadPage ? 'Reloading' : null;
                if (this.shouldReloadPage)
                    window.location.reload();
            },
            error: () => {
                this.loadingMessage = null;
                this.errorText = 'Problem updating holdings.';
            },
        });
    }
    /**
     * Reset the error text and set the default securites as related securities.
     */
    restoreDefaults() {
        this.errorText = '';
        this.relatedHoldings = [...this.defaultRelatedHoldings];
    }
    /**
     * Removes a related security from the list.
     *
     * @param index: Index of the removed security.
     */
    removeRelatedSecurity(index) {
        this.errorText = '';
        this.relatedHoldings.splice(index, 1);
    }
    /**
     * Handler for the security autocomplete input. Triggerd when a security from the dropdown results list is
     * selected.
     *
     * @param securityObject: Selected security.
     */
    autocompleteHandler(securityObject) {
        if (!securityObject)
            return;
        let error;
        const newUserRelatedSecurity = {
            securityId: securityObject.search_id,
            displaySecurityId: securityObject.display_security_id,
            name: securityObject.name,
        };
        // Check if the security is already in the list.
        const existingIndex = this.relatedHoldings.findIndex((sec) => sec.securityId === newUserRelatedSecurity.securityId);
        if (existingIndex !== -1) {
            error = `${newUserRelatedSecurity.securityId} already in the list.`;
        }
        // Check if already at max holdings
        if (this.relatedHoldings.length >= this.maxHoldings) {
            error = `No more than ${this.maxHoldings} holdings are allowed.`;
        }
        if (error) {
            this.errorText = error;
            return;
        }
        this.relatedHoldings.splice(0, 0, newUserRelatedSecurity);
        this.errorText = '';
    }
    /**
     * Updates the ordering of the related securities.
     * @param oldIndex: Old list index.
     * @param newIndex: New list index.
     */
    updateOrdering(oldIndex, newIndex) {
        if (oldIndex !== undefined && newIndex !== undefined) {
            this.relatedHoldings.splice(newIndex, 0, this.relatedHoldings.splice(oldIndex, 1)[0]);
        }
    }
    /**
     * Sets up Sortable drag and drop for the holdings list.
     */
    initializeSortable() {
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.holdingsContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (evt) => {
                    // The Sortable instance is created outside of Angular, so we need to run the update inside the Angular zone.
                    this.ngZone.run(() => {
                        this.updateOrdering(evt.oldIndex, evt.newIndex);
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in container for tooltip/sortable bug
                    disablePointerEvents(document, 'plate-container');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'plate-container');
                },
            });
        });
        this.sortableInitialized = true;
    }
    trackBySecurityId(index, holding) {
        return holding.securityId;
    }
}
EditHoldingsModalComponent.ɵfac = function EditHoldingsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditHoldingsModalComponent)(i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i0.NgZone)); };
EditHoldingsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditHoldingsModalComponent, selectors: [["ycn-edit-holdings-modal"]], viewQuery: function EditHoldingsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.holdingsContainer = _t.first);
    } }, inputs: { maxHoldings: "maxHoldings", maxDisplayHoldings: "maxDisplayHoldings", securityId: "securityId", shouldReloadPage: "shouldReloadPage", showRestoreDefaults: "showRestoreDefaults" }, standalone: false, decls: 13, vars: 8, consts: [["holdingsContainer", ""], [3, "closeModalHandler", "open", "requiresAction"], [1, "modal-header"], [1, "modal-title"], [1, "modal-header-actions"], [1, "modal-header-action"], ["class", "btn btn-modal-header", 3, "click", 4, "ngIf"], [1, "btn", "btn-modal-header", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], ["class", "loader", 4, "ngIf"], ["class", "modal-body", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "errorText", "submitButtonText"], [1, "btn", "btn-modal-header", 3, "click"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "divider-horizontal"], [3, "submitHandler", "searchType", "searchableSecurityIds", "isDisabled"], [1, "form-row", "user-select-none"], [1, "plates", "plates-view-list"], ["class", "plate-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "plate-container"], [1, "plate", 3, "ngClass"], [1, "plate-header"], [1, "plate-title"], [1, "plate-title-abbr"], [1, "plate-title-name"], [1, "plate-controls"], ["ycnTooltip", "", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "btn-reorder-up", "plate-control"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"]], template: function EditHoldingsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function EditHoldingsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3, "Edit Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, EditHoldingsModalComponent_div_6_Template, 3, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 7);
        i0.ɵɵlistener("click", function EditHoldingsModalComponent_Template_div_click_8_listener() { return ctx.closeModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 8);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(10, EditHoldingsModalComponent_div_10_Template, 4, 1, "div", 9)(11, EditHoldingsModalComponent_div_11_Template, 12, 6, "div", 10);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "ycn-simple-modal-footer", 11);
        i0.ɵɵlistener("cancelHandler", function EditHoldingsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_12_listener() { return ctx.closeModal(); })("submitHandler", function EditHoldingsModalComponent_Template_ycn_simple_modal_footer_submitHandler_12_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open)("requiresAction", true);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.showRestoreDefaults);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loadingMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loadingMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorText", ctx.errorText)("submitButtonText", "Update");
    } }, dependencies: [i2.AddButtonAutocompleteComponent, i3.NgClass, i3.NgForOf, i3.NgIf, i4.IconDirective, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.TooltipDirective], encapsulation: 2 });
